import React, { useState, useEffect } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase"; // Adjust based on project structure
import { useNavigate } from "react-router-dom";
const LeaveAllocation = () => {
  const navigate = useNavigate();
   useEffect(() => {
      if(sessionStorage.getItem("login") !== "true"){
        navigate("/")
      }
    }, [])

  const [empid, setEmpid] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [leaveData, setLeaveData] = useState(null);
  const currentlogin = localStorage.getItem("empid")
  const [options, setOptions] = useState([]);
  console.log(localStorage.getItem("empid"))
  useEffect(() => {
    const addOptions = () => {
      
      if(currentlogin == "37" || currentlogin == "38" || currentlogin == "39" || currentlogin == "40" || currentlogin=="41" || currentlogin == "82" || currentlogin == "83" || currentlogin == "84" || currentlogin == "85" || currentlogin == "86")
      {
        document.getElementById("updatebtn").hidden = true
      }
      if (currentlogin == "31") {
        const newOptions = [
          { value: "82", label: "Kalimpong SS & Head" },
          { value: "1", label: "Kalimpong SMS Horticulture" },
          { value: "2", label: "Kalimpong SMS Soil Science" },
          { value: "3", label: "Kalimpong SMS Plant Protection" },
          { value: "4", label: "Kalimpong SMS Animal Science" },
          { value: "5", label: "Kalimpong SMS Home Science" },
          { value: "6", label: "Kalimpong SMS Extension" },
          { value: "37", label: "Kalimpong Accountant" },
          { value: "42", label: "Kalimpong Farm Manager"},
          { value: "47", label: "Kalimpong Computer Programmer"},
          { value: "52", label: "Kalimpong Programme Assistant"},
          { value: "57", label: "Kalimpong Stenographer"},
          { value: "62", label: "Kalimpong Driver1"},
          { value: "63", label: "Kalimpong Driver2"},
          { value: "72", label: "Kalimpong Skilled Supporting Staff1"},
          { value: "73", label: "Kalimpong Skilled Supporting Staff2"},

          { value: "83", label: "Coochbehar SS & Head" },
          { value: "7", label: "Coochbehar SMS Horticulture" },
          { value: "8", label: "Coochbehar SMS Soil Science" },
          { value: "9", label: "Coochbehar SMS Plant Protection" },
          { value: "10", label: "Coochbehar SMS Agronomy" },
          { value: "11", label: "Coochbehar SMS Animal Science" },
          { value: "12", label: "Coochbehar SMS Extension" },
          { value: "38", label: "Coochbehar Accountant" },
          { value: "43", label: "Coochbehar Farm Manager"},
          { value: "48", label: "Coochbehar Computer Programmer"},
          { value: "53", label: "Coochbehar Programme Assistant"},
          { value: "58", label: "Coochbehar Stenographer"},
          { value: "64", label: "Coochbehar Driver1"},
          { value: "65", label: "Coochbehar Driver2"},
          { value: "74", label: "Coochbehar Skilled Supporting Staff1"},
          { value: "75", label: "Coochbehar Skilled Supporting Staff2"},

          { value: "84", label: "Uttar Dinajpur SS & Head" },
          { value: "13", label: "Uttar Dinajpur SMS Horticulture" },
          { value: "14", label: "Uttar Dinajpur SMS Agronomy" },
          { value: "15", label: "Uttar Dinajpur SMS Plant Protection" },
          { value: "16", label: "Uttar Dinajpur SMS Animal Science" },
          { value: "17", label: "Uttar Dinajpur SMS Home Science" },
          { value: "18", label: "Uttar Dinajpur SMS Fishery Science" },
          { value: "39", label: "Uttar Dinajpur Accountant" },
          { value: "44", label: "Uttar Dinajpur Farm Manager"},
          { value: "49", label: "Uttar Dinajpur Computer Programmer"},
          { value: "54", label: "Uttar Dinajpur Programme Assistant"},
          { value: "59", label: "Uttar Dinajpur Stenographer"},
          { value: "66", label: "Uttar Dinajpur Driver1"},
          { value: "67", label: "Uttar Dinajpur Driver2"},
          { value: "76", label: "Uttar Dinajpur Skilled Supporting Staff1"},
          { value: "77", label: "Uttar Dinajpur Skilled Supporting Staff2"},

          { value: "85", label: "Dakshin Dinajpur SS & Head" },
          { value: "19", label: "Dakshin Dinajpur SMS Horticulture" },
          { value: "20", label: "Dakshin Dinajpur SMS Soil Science" },
          { value: "21", label: "Dakshin Dinajpur SMS Agronomy" },
          { value: "22", label: "Dakshin Dinajpur SMS Animal Science" },
          { value: "23", label: "Dakshin Dinajpur SMS Plant Protection" },
          { value: "24", label: "Dakshin Dinajpur SMS Fishery Science" },
          { value: "40", label: "Dakshin Dinajpur Accountant" },
          { value: "45", label: "Dakshin Dinajpur Farm Manager"},
          { value: "50", label: "Dakshin Dinajpur Computer Programmer"},
          { value: "55", label: "Dakshin Dinajpur Programme Assistant"},
          { value: "60", label: "Dakshin Dinajpur Stenographer"},
          { value: "68", label: "Dakshin Dinajpur Driver1"},
          { value: "69", label: "Dakshin Dinajpur Driver2"},
          { value: "78", label: "Dakshin Dinajpur Skilled Supporting Staff1"},
          { value: "79", label: "Dakshin Dinajpur Skilled Supporting Staff2"},

          { value: "86", label: "Malda SS & Head" },
          { value: "25", label: "Malda SMS Horticulture" },
          { value: "26", label: "Malda SMS Agronomy" },
          { value: "27", label: "Malda SMS Plant Protection" },
          { value: "28", label: "Malda SMS Animal Science" },
          { value: "29", label: "Malda SMS Extension" },
          { value: "30", label: "Malda SMS Fishery Science" },
          { value: "41", label: "Malda Accountant" },
          { value: "46", label: "Malda Farm Manager"},
          { value: "51", label: "Malda Computer Programmer"},
          { value: "56", label: "Malda Programme Assistant"},
          { value: "61", label: "Malda Stenographer"},
          { value: "70", label: "Malda Driver1"},
          { value: "71", label: "Malda Driver2"},
          { value: "80", label: "Malda Skilled Supporting Staff1"},
          { value: "81", label: "Malda Skilled Supporting Staff2"},
        ];
        setOptions(newOptions);
      }
      

    }
    addOptions();
  }, [currentlogin])


  const defaultLeave = {
    acl: 0, ael: 0, aml: 0, accl: 0, aodl: 0,
    ucl: 0, uel: 0, uml: 0, uccl: 0, uodl: 0,
    bcl: 0, bel: 0, bml: 0, bccl: 0, bodl: 0,
  };

  useEffect(() => {
    const fetchLeaveData = async () => {
      if (!empid || !selectedYear) return;

      try {
        console.log(`Fetching for empid: ${empid}, year: ${selectedYear}`);
        const leaveRef = doc(db, "empmaster", empid, selectedYear, "leave");
        const docSnap = await getDoc(leaveRef);

        if (docSnap.exists()) {
          console.log("Fetched Data from Firestore:", docSnap.data());
          setLeaveData(docSnap.data());
        } else {
          console.log("No leave data found. Initializing defaults.");
          setLeaveData(defaultLeave);
        }
      } catch (error) {
        console.error("Error fetching leave data:", error);
      }
    };

    fetchLeaveData();
  }, [empid, selectedYear]);

  // Handle input change
  const handleInputChange = (e, key) => {
    setLeaveData((prev) => ({
      ...prev,
      [key]: Number(e.target.value),
    }));
  };

  // Update Firestore
  const updateLeaveData = async () => {
    if (!empid || !selectedYear) {
      alert("Please select an employee and Calender Year first.");
      return;
    }

    try {
      console.log("Updating Firestore with:", leaveData);
      const leaveRef = doc(db, "empmaster", empid, selectedYear, "leave");
      await setDoc(leaveRef, leaveData, { merge: true });
      alert("Leave data updated successfully!");
    } catch (error) {
      console.error("Error updating leave data:", error);
      alert("Failed to update leave data.");
    }
  };

  const handleBack =(e)=>{
    e.preventDefault();
    navigate(-1)
  }

  return (
    <div className="container">
      {/* SMS Dropdown */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
        <h1 className="welcome">Leave Allocation for</h1>
        <select
          className="dropdown"
          value={empid}
          onChange={(e) => setEmpid(e.target.value)}
          style={{ width: "300px", height: "40px" }}
        >
          <option value="">Select SMS</option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      {/* Financial Year Selection */}
      <center>
        <select className="dropdown" value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)} style={{ width: "300px", height: "40px", marginTop: "10px" }}>
          <option value="">Select Calender Year</option>
          {["2025", "2026", "2027", "2028"].map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>
      </center>

      {/* Leave Table */}
      <table className="budget-table">
        <thead>
          <tr>
            <th style={{ width: "100px" }}>Leave Account</th>
            {["Casual Leave", "Earned Leave", "Meical Leave", "Chield Care Leave", "On Duty Leave"].map((header) => (
              <th key={header} style={{ width: "60px" }}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Allocation</td>
            {Object.keys(defaultLeave).slice(0, 5).map((key) => (
              <td key={key}><input type="number" value={leaveData?.[key] || 0} onChange={(e) => handleInputChange(e, key)} style={{ width: "60px", textAlign: "center" }} /></td>
            ))}
          </tr>
          <tr>
            <td>Utilized</td>
            {Object.keys(defaultLeave).slice(5, 10).map((key) => (
              <td key={key}><input type="number" className="myutil" value={leaveData?.[key] || 0} onChange={(e) => handleInputChange(e, key)} style={{ width: "60px", textAlign: "center" }} /></td>
            ))}
          </tr>
          <tr>
            <td>Balance</td>
            {Object.keys(defaultLeave).slice(0, 5).map((key, index) => (
              <td key={key}>{(leaveData?.[key] || 0) - (leaveData?.[Object.keys(defaultLeave)[index + 5]] || 0)}</td>
            ))}
          </tr>
        </tbody>
      </table>

      {/* Update Button */}
      <center>
        <button id="updatebtn" onClick={updateLeaveData} style={{ marginTop: "20px", padding: "10px 20px", fontSize: "16px", backgroundColor: "green", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>
          Update
        </button>
      </center>

      <br /><br /><br /><br />

      <center>
        <img src="/assets/back.png" style={{ width: '100px'}} onClick={handleBack} alt="" />
      </center>
    </div>
  );
};

export default LeaveAllocation;
